var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-fields" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10, type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _vm._v("模版名称："),
              _c("el-input", {
                attrs: {
                  type: "text",
                  disabled: +_vm.item.sceneType === 1,
                  placeholder: "请输入模版名称",
                  clearable: ""
                },
                model: {
                  value: _vm.form.sceneName,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "sceneName", $$v)
                  },
                  expression: "form.sceneName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 4 } }),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c("el-input", {
                attrs: {
                  type: "text",
                  placeholder: "请输入字段关键字检索",
                  clearable: "",
                  "suffix-icon": "el-icon-search"
                },
                on: { clear: _vm.clear },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchCheckBox.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.form.value,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "value", $$v)
                  },
                  expression: "form.value"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.searchCheckBox }
                },
                [_vm._v("检索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { staticClass: "organization", attrs: { span: 10 } },
            [
              _vm._v("\n      授权组织："),
              _c("ybl-select-tree", {
                attrs: { filterDelete: false, showCheckbox: true },
                model: {
                  value: _vm.form.orgAuthorization,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "orgAuthorization", $$v)
                  },
                  expression: "form.orgAuthorization"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      +_vm.busiType === 200
        ? _c(
            "div",
            { staticClass: "template-fields__box" },
            [
              _c(
                "draggable",
                {
                  attrs: {
                    draggable: ".template-fields__row,.item",
                    disabled: +_vm.item.sceneType === 1
                  },
                  on: { change: _vm.dragChange },
                  model: {
                    value: _vm.rightItems,
                    callback: function($$v) {
                      _vm.rightItems = $$v
                    },
                    expression: "rightItems"
                  }
                },
                _vm._l(_vm.rightItems, function(ite, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "template-fields__row" },
                    [
                      _c(
                        "div",
                        { staticClass: "template-fields__checkbox__title" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: {
                                indeterminate: ite.isIndeterminate,
                                disabled: _vm.item.sceneType === 1
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleCheckAllChange($event, ite)
                                }
                              },
                              model: {
                                value: ite.checkAll,
                                callback: function($$v) {
                                  _vm.$set(ite, "checkAll", $$v)
                                },
                                expression: "ite.checkAll"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("groupName")(ite[_vm.props.groupName])
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: "_" + index,
                          staticClass: "template-fields__checkbox__box"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "template-fields__checkbox__checkedItems"
                            },
                            [
                              _c(
                                "draggable",
                                {
                                  attrs: {
                                    draggable: ".item",
                                    disabled: +_vm.item.sceneType === 1
                                  },
                                  on: { change: _vm.dragChange },
                                  model: {
                                    value: ite[_vm.props.checked],
                                    callback: function($$v) {
                                      _vm.$set(ite, _vm.props.checked, $$v)
                                    },
                                    expression: "ite[props.checked]"
                                  }
                                },
                                [
                                  _vm._l(ite[_vm.props.checked], function(
                                    child,
                                    cIndex
                                  ) {
                                    return [
                                      _c(
                                        "el-checkbox",
                                        {
                                          key:
                                            "_checkbox_" + child[_vm.props.id],
                                          staticClass: "item",
                                          attrs: {
                                            label: child[_vm.props.id],
                                            disabled: +_vm.item.sceneType === 1
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.checkBoxChange(
                                                cIndex,
                                                ite
                                              )
                                            }
                                          },
                                          model: {
                                            value: child.checked,
                                            callback: function($$v) {
                                              _vm.$set(child, "checked", $$v)
                                            },
                                            expression: "child.checked"
                                          }
                                        },
                                        [_vm._v(_vm._s(child[_vm.props.label]))]
                                      )
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "template-fields__checkbox__items" },
                            [
                              _vm._l(ite[_vm.props.children], function(
                                child,
                                cIndex
                              ) {
                                return [
                                  _c(
                                    "el-checkbox",
                                    {
                                      key: "_checkbox_" + child[_vm.props.id],
                                      attrs: {
                                        label: child[_vm.props.id],
                                        disabled: +_vm.item.sceneType === 1
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.rightCheckBoxChange(
                                            cIndex,
                                            ite
                                          )
                                        }
                                      },
                                      model: {
                                        value: child.checked,
                                        callback: function($$v) {
                                          _vm.$set(child, "checked", $$v)
                                        },
                                        expression: "child.checked"
                                      }
                                    },
                                    [_vm._v(_vm._s(child[_vm.props.label]))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        : _c("div", { staticClass: "template-fields__container" }, [
            _c(
              "div",
              { staticClass: "template-fields__checkbox__left" },
              [
                _c(
                  "draggable",
                  {
                    attrs: { draggable: ".item" },
                    on: { change: _vm.dragChange },
                    model: {
                      value: _vm.leftCheckedItems,
                      callback: function($$v) {
                        _vm.leftCheckedItems = $$v
                      },
                      expression: "leftCheckedItems"
                    }
                  },
                  [
                    _vm._l(_vm.leftCheckedItems, function(child, cIndex) {
                      return [
                        _c(
                          "el-checkbox",
                          {
                            key: "_checkbox_" + child[_vm.props.id],
                            staticClass: "item",
                            attrs: { label: child[_vm.props.id] },
                            on: {
                              change: function($event) {
                                return _vm.leftCheckBoxChange(cIndex, child)
                              }
                            },
                            model: {
                              value: child.checked,
                              callback: function($$v) {
                                _vm.$set(child, "checked", $$v)
                              },
                              expression: "child.checked"
                            }
                          },
                          [_vm._v(_vm._s(child[_vm.props.label]))]
                        )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "template-fields__box" },
              _vm._l(_vm.rightItems, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "template-fields__row" },
                  [
                    _c(
                      "div",
                      {
                        key: "_" + index,
                        staticClass: "template-fields__checkbox__box1"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "template-fields__checkbox__title" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { indeterminate: item.isIndeterminate },
                                on: {
                                  change: function($event) {
                                    return _vm.handleCheckAllChange(
                                      $event,
                                      item
                                    )
                                  }
                                },
                                model: {
                                  value: item.checkAll,
                                  callback: function($$v) {
                                    _vm.$set(item, "checkAll", $$v)
                                  },
                                  expression: "item.checkAll"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("groupName")(
                                      item[_vm.props.groupName]
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "template-fields__checkbox__items" },
                          [
                            _vm._l(item[_vm.props.children], function(
                              child,
                              cIndex
                            ) {
                              return [
                                _c(
                                  "el-checkbox",
                                  {
                                    key: "_checkbox_" + child[_vm.props.id],
                                    attrs: { label: child[_vm.props.id] },
                                    on: {
                                      change: function($event) {
                                        return _vm.rightCheckBoxChange(
                                          cIndex,
                                          item
                                        )
                                      }
                                    },
                                    model: {
                                      value: child.checked,
                                      callback: function($$v) {
                                        _vm.$set(child, "checked", $$v)
                                      },
                                      expression: "child.checked"
                                    }
                                  },
                                  [_vm._v(_vm._s(child[_vm.props.label]))]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "template-fields__header" }, [
      _c("div", { staticClass: "template-fields__header__item" }, [
        _c("div", { staticClass: "item__content" }, [_vm._v("已选字段")]),
        _vm._v(" "),
        _c("div", { staticClass: "item__tip font12" }, [_vm._v("*可拖动排序")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "template-fields__header__item" }, [
        _c("div", { staticClass: "item__content" }, [_vm._v("未选字段")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8aebb866", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8aebb866","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/components/templateFields.vue
// module id = null
// module chunks = 